var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-grey-lighter"
  }, [_c('div', {
    staticClass: "flex flex-col md:flex-row py-16 px-4 md:px-a container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "w-full md:w-1/2"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "line line-left mt-4 mb-6"
  }), _vm._v(" "), _c('p', {
    staticClass: "leading-normal"
  }, [_vm._v("\n       A simple query to a WHOIS server is all well and good however doing something meaningful and programmatic with the data returned is a whole other story. This is where we step in, here at JsonWhoisAPI we put our experience in turning the data provided with no standards what so ever into a consistent machine usable Json format. We let you get on with building your app without having to think about the mess that is WHOIS.\n       ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col my-4"
  }, [_c('div', {
    staticClass: "bg-white flex items-center cursor-pointer",
    on: {
      "click": function($event) {
        _vm.openSection('intelicache')
      }
    }
  }, [_c('div', {
    staticClass: "bg-blue p-2"
  }, [_c('svg', {
    staticClass: "fill-current h-6 w-6 text-white",
    attrs: {
      "viewBox": "0 0 20 20",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('title', [_vm._v("Intelicache")]), _c('path', {
    attrs: {
      "d": "M1 4h2v2H1V4zm4 0h14v2H5V4zM1 9h2v2H1V9zm4 0h14v2H5V9zm-4 5h2v2H1v-2zm4 0h14v2H5v-2z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mx-4"
  }, [_vm._v("Intelicache")])]), _vm._v(" "), (_vm.activeSection === 'intelicache') ? _c('div', {
    staticClass: "bg-white mt-1 p-2 leading-normal"
  }, [_c('p', [_vm._v("The inconsistencies that exists from WHOIS server to WHOIS server mean that some servers require more advanced caching than others. Using our proprietary caching formula, Intelicache, we endeavour to bring you the fastest most up to date results possible, providing a stable platform to build your app upon.")]), _vm._v(" "), _c('p', [_vm._v("Intelicache leverages the collective WHOIS requests sent to our servers alongside our advanced crawling and auto updating service to provide a speedy and consistent experience. ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col my-4"
  }, [_c('div', {
    staticClass: "bg-white flex items-center cursor-pointer",
    on: {
      "click": function($event) {
        _vm.openSection('api')
      }
    }
  }, [_c('div', {
    staticClass: "bg-blue p-2"
  }, [_c('svg', {
    staticClass: "fill-current h-6 w-6 text-white",
    attrs: {
      "viewBox": "0 0 20 20",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('title', [_vm._v("REST API")]), _c('path', {
    attrs: {
      "d": "M.7 9.3l4.8-4.8 1.4 1.42L2.84 10l4.07 4.07-1.41 1.42L0 10l.7-.7zm18.6 1.4l.7-.7-5.49-5.49-1.4 1.42L17.16 10l-4.07 4.07 1.41 1.42 4.78-4.78z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mx-4"
  }, [_vm._v("REST API")])]), _vm._v(" "), (_vm.activeSection === 'api') ? _c('div', {
    staticClass: "bg-white mt-1 p-2 leading-normal"
  }, [_vm._m(2), _vm._v(" "), _c('p', [_vm._v("We convert unorignaised WHOIS data into a structured Json object.")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col my-4"
  }, [_c('div', {
    staticClass: "bg-white flex items-center cursor-pointer",
    on: {
      "click": function($event) {
        _vm.openSection('service')
      }
    }
  }, [_c('div', {
    staticClass: "bg-blue p-2"
  }, [_c('svg', {
    staticClass: "fill-current h-6 w-6 text-white",
    attrs: {
      "viewBox": "0 0 20 20",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('title', [_vm._v("Your service")]), _c('path', {
    attrs: {
      "d": "M19.95 11A10 10 0 1 1 9 .05V11h10.95zm-.08-2.6H11.6V.13a10 10 0 0 1 8.27 8.27z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mx-4"
  }, [_vm._v("Your service")])]), _vm._v(" "), (_vm.activeSection === 'service') ? _c('div', {
    staticClass: "bg-white mt-1 p-2 leading-normal"
  }, [_c('p', [_vm._v("A service can have all the features you are looking for with a well-defined interface for usage however, if there is call throttling or a ludicrous pricing structure in place it can all mean nothing. We operate on a simple tiered pay as you go pricing structure giving you the freedom to pay only for what you use - perfect for any size business. Calls to our parsed WHOIS data service are not throttled at all meaning you don’t have to worry about this service being a bottleneck to yours!")])]) : _vm._e()])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full md:w-1/2 text-center"
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/apis.png"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "text-4xl text-grey-darkest"
  }, [_c('strong', {
    staticClass: "text-black"
  }, [_vm._v("Strive")]), _vm._v(" for the best")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Our core service is providing a single reliable interface to the sketchy world of WHOIS data. We eat, sleep, and breath REST APIs - they are simple and powerful thus JsonWhoisAPI was built with such an API as the center piece. The API "), _c('a', {
    attrs: {
      "href": "docs"
    }
  }, [_vm._v("documentation")]), _vm._v(" is clear and to the point and provides useful code samples, we have built the kind of API we would love to use.")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15b4c385","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/home/service-info.vue
// module id = 670
// module chunks = 0